import { useCallback } from 'react';
import { MenuItem, Select } from '@mui/material';
import {
  PS_STATUS_DONOTADD,
  PS_STATUS_EVALUATING,
  PS_STATUS_PENDING,
  PS_STATUS_READY
} from './PSAppConstants';

export default function PSStatusEdit(props) {
  const { id, field, value, api } = props;

  const handleChange = useCallback(
    (event) => {
      api.setEditCellValue({ id, field, value: event.target.value }, event);
      api.stopCellEditMode({ id, field });
    },
    [api, field, id]
  );

  return (
    <Select defaultOpen={true} value={value} onChange={handleChange}>
      <MenuItem value={PS_STATUS_READY}>{PS_STATUS_READY}</MenuItem>
      <MenuItem value={PS_STATUS_EVALUATING}>{PS_STATUS_EVALUATING}</MenuItem>
      <MenuItem value={PS_STATUS_PENDING}>{PS_STATUS_PENDING}</MenuItem>
      <MenuItem value={PS_STATUS_DONOTADD}>{PS_STATUS_DONOTADD}</MenuItem>
    </Select>
  );
}
